import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, FileCheck } from 'lucide-react';
const items = ['1 Evaluación diagnóstica por grado (6 en total)', '18 exámenes trimestrales listos para fotocopiar', '6 evaluaciones especiales por contenido crítico', '6 hojas de claves y respuestas', '6 rúbricas analíticas alineadas al CFE', '6 planillas de registro de notas por grado', '1 Gran Examen Integrador de Primaria (Egreso de 6°)', 'Registro de desempeño trimestral para el legajo', 'Guía de recuperatorios con modelo listo', 'Banco de frases para informes de calificación', 'Modelos de notas para cuaderno de comunicaciones', 'Plantilla de evaluación adaptada para inclusión', 'Checklist de carpeta didáctica para supervisión', 'Calendario de evaluaciones 2026 completo', 'Autoevaluación para el alumno'];
export const MasterKitIncludes = () => {
  return <section className="py-20 bg-brand-green text-white" data-id="element-169">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-170">
        <div className="text-center mb-12" data-id="element-171">
          <div className="inline-block bg-brand-gold/20 p-4 rounded-full mb-6" data-id="element-172">
            <FileCheck size={40} className="text-brand-gold" data-id="element-173" />
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold mb-4 text-brand-gold" data-id="element-174">
            MASTER KIT DE EVALUACIÓN™ INCLUYE:
          </h2>
          <p className="text-xl text-cream/90" data-id="element-175">
            60 páginas de herramientas evaluativas listas para usar:
          </p>
        </div>

        <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-white/10" data-id="element-176">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-8" data-id="element-177">
            {items.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="flex items-start gap-3" data-id="element-178">
                <CheckCircle2 size={20} className="text-brand-gold flex-shrink-0 mt-0.5" data-id="element-179" />
                <span className="text-cream/90 text-sm md:text-base" data-id="element-180">
                  {item}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
};